<template>
  <div>
    <v-dialog
      v-model="dialog"
      content-class="custom-product-dialog"
      transition="dialog-bottom-transition"
      width="70%"
      persistent
    >
      <div class="content-dialog">
        <div class="heading-wrapper">
          <p class="filter-text">Filters</p>
          <div @click="toggleDialog" style="cursor: pointer">
            <v-icon color="#1F8F58" style="width: 20px; height: 20px"
              >mdi-close</v-icon
            >
          </div>
        </div>
        <hr
          style="
            border: 0.5px solid #efefef;
            background-color: #efefef;
            color: #efefef;
          "
        />
        <div
          style="
            display: flex;
            padding: 5px;
            justify-content: space-between;
            height: 460px;
            padding: 20px 20px 0px 0px;
            overflow: hidden;
          "
        >
          <div style="width: 20%; margin-left: 6px">
            <div
              v-for="(engagement, index) in engagements"
              :key="index"
              style="
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                color: #777777;
                padding-top: 4px;
                height: 40px;
                padding-left: 12px;
                cursor: pointer;
              "
              @click="selectEngagement(engagement)"
              :class="{ selected: selectedEngagement === engagement }"
            >
              <p :class="{ selected: selectedEngagement === engagement }">
                {{ engagement }}
              </p>
            </div>
          </div>
          <div
            style="
              width: 1px;
              border: 0.5px solid #e3e3e3;
              background-color: #e3e3e3;
              color: #e3e3e3;
              margin-right: 8px;
            "
          ></div>
          <div style="width: 79%; overflow-y: scroll">
            <div v-if="selectedEngagement === 'Location'" key="Location">
              <p class="heading">Location</p>
              <location-tab type="location" :data="locations" key="location" />
              <!-- <location-tab :locations="locations"/> -->
              <!-- <v-expansion-panels
                class="expand"
                v-for="locations in locations"
                :key="locations.id"
              >
                <v-expansion-panel
                  style="
                    margin-top: 0rem;
                    border: none !important;
                    margin-bottom: 4px !important;
                  "
                  :accordion="true"
                >
                  <v-expansion-panel-header style="height: 40px">
                    <div
                      @click="handleStateSelected(locations.id)"
                      style="display: flex; align-items: end"
                      :key="locations.id"
                    >
                      <question-tab
                        :showDropdownQuestion="true"
                        :heading="locations.eng_name"
                      />
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <multiple-button
                      type="districts"
                      :data="districtData"
                      :stateId="locations"
                      ref="otherInterestsRef"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> -->
            </div>

            <div
              class="expand"
              v-if="selectedEngagement === 'Interests'"
              key="Interests"
            >
              <p class="heading">Interests</p>
              <div style="margin-top: 32px; margin-bottom: 40px">
                <multiple-button
                  type="interests"
                  heading="Business Interests"
                  :data="interests.business_interest_list"
                  key="interests"
                  ref="otherInterestsRef"
                />
              </div>
              <multiple-button
                type="otherInterests"
                heading="Other Interests"
                :data="interests.other_interest_list"
                key="otherInterests1"
              />
            </div>
            <div
              class="expand"
              v-if="selectedEngagement === 'Insurance'"
              key="Insurance"
            >
              <p class="heading">Insurance</p>

              <div
                style="display: flex; align-items: end; border: none !important"
              >
                <insurance-tab :showDropdownQuestion="false" />
              </div>
            </div>
            <div
              class="expand"
              v-if="selectedEngagement === 'Ownership'"
              key="Ownership"
            >
              <p class="heading">Ownership</p>
              <ownership-tab />
              <!-- <div
                style="display: flex; align-items: end; border: none !important"
              >
                <question-tab
                  :showDropdownQuestion="false"
                  heading="Does the farmer have any Land?"
                />
              </div> -->
            </div>
            <div v-if="selectedEngagement === 'Crops'" key="crops">
              <p class="heading">Cropping Profile</p>
              <!-- <crop-tab/> -->
              <v-expansion-panels
                class="expand"
                v-for="(crop, index) in crops"
                :key="index"
              >
                <v-expansion-panel
                  style="
                    margin-top: 0rem;
                    border: none !important;
                    margin-bottom: 4px;
                  "
                >
                  <v-expansion-panel-header style="height: 40px">
                    <!-- <div style="display: flex; align-items: end">
                      <question-tab
                        :showDropdownQuestion="true"
                        :heading="crop.crop_type"
                      />

                      <input
                        type="checkbox"
                        style="transform: translateY(-16px); margin-right: 18px"
                      />

                      <p>{{ crop.crop_type }}</p>
                    </div> -->
                    <header-div :cropType="crop" type="crops" />
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <multiple-button
                      type="crops"
                      :data="crop.crops"
                      :cropType="crop.crop_type_id"
                    />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
            <div class="expand" v-if="selectedEngagement === 'Brands'">
              <p class="heading">Brands</p>

              <brands-button
                heading="Brand List"
                type="brands"
                :data="brands"
                ref="brandsRef"
                :getData="getSelectedBrand"
              />
            </div>
            <div class="expand" v-if="selectedEngagement === 'Engagement'">
              <p class="heading">Engagement</p>
              <engagemen-tab />
              <!-- <v-expansion-panels>
                <v-expansion-panel
                  style="margin-top: 0rem; border: none !important"
                >
                  <v-expansion-panel-header style="height: 40px">
                    <div style="display: flex; align-items: end">
                      <question-tab heading="Does the farmer have any Land?" />
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <input-button />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels> -->
            </div>
          </div>
        </div>
        <hr
          style="
            border: 0.5px solid #efefef;
            background-color: #efefef;
            color: #efefef;
          "
        />
        <div
          style="
            display: flex;
            padding: 20px 20px 0px 20px;
            justify-content: space-between;
          "
        >
          <p></p>
          <button
            class="publish green-background white--text bold"
            v-ripple
            @click="checkActionAndAct"
            style="height: 40px"
          >
            Apply Filter
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import questionTab from "./question.vue";
import multipleAnswers from "./multiple-answer.vue";
import multipleButton from "./multiple-button.vue";
import inputbutton from "./inputbutton.vue";
import API_URL from "../../../../helpers/apiUrls";
import brandsMultipleButton from "./brands-button.vue";
import insuranceTab from "../components/insurance.vue";
import engagementTab from "../components/engagement-tab.vue";
import cropTab from "../components/crops-tab.vue";
import headerDiv from "./heading-div.vue";
import locationTab from "./location-tabs.vue";
import ownerShip from "./ownership.vue";
export default {
  name: "filterModal",
  data() {
    return {
      defaultImage: require("../../../../assets/logo/greenCheck.svg"),
      engagements: [
        "Location",
        "Interests",
        "Crops",
        "Insurance",
        "Ownership",

        "Brands",
        "Engagement",
      ], // Add more engagements if needed
      selectedEngagement: "Location",
      locations: [],
      districtData: [],
      interests: null,
      statedId: "",
      crops: null,
      brands: null,
      dialog: false,
      selectAll: false,
      isButtonSelected: false,
      // selectedBrands: [],
      selectedPanelIndex: null,
    };
  },
  props: {
    // dialog: {
    //     default: false,
    // },
    getUserDetails: Function,
    isfilterApplied: Function,
  },
  components: {
    "question-tab": questionTab,
    "multiple-answer": multipleAnswers,
    "multiple-button": multipleButton,
    "input-button": inputbutton,
    "brands-button": brandsMultipleButton,
    "insurance-tab": insuranceTab,
    "engagemen-tab": engagementTab,
    " crop-tab": cropTab,
    "header-div": headerDiv,
    "location-tab": locationTab,
    "ownership-tab": ownerShip,
  },
  watch: {
    "$store.state": {
      handler(newVal, oldVal) {
        // Handle state change
        console.log("State changed:", newVal, oldVal);
      },
      deep: true, // Watch for nested changes if applicable
    },
  },
  mounted() {
    this.getStateList();
    this.getBrands(), this.getCrops();
    this.interestAPIcall();
  },
  methods: {
    selectEngagement(engagement) {
      this.selectedEngagement = engagement;
      if (this.selectedEngagement == "brands") this.interestAPIcall();
      // console.log(
      //   "this.$refs.brandsRef.selectedBrands",
      //   this.$refs.otherInterestsRef.selectedIntersets
      // );

      this.$store.dispatch(
        "crmFilters/setInterests",
        this.$refs.otherInterestsRef.selectedIntersets
      );
      this.$store.dispatch(
        "crmFilters/setOtherInterests",
        this.$refs.otherInterestsRef1.otherInterests
      );
    },
    toggleDialog() {
      this.dialog = !this.dialog; // Toggles the value of `dialog` between true and false
    },
    open() {
      this.dialog = true; // Sets the dialog property to true when the 'open' method is called
    },
    handleSelectAllChanged(checked) {
      this.selectAll = checked;
    },
    updateButtonSelection(isSelected) {
      this.isButtonSelected = isSelected;
    },
    getStateList() {
      const successHandler = (response) => {
        if (response.status === 200) {
          this.locations = response.data.results;
        }
      };

      const errorHandler = (response) => {
        this.showToast("Something went wrong internally!", "error", 10000);
      };

      this.requestGET(
        `${API_URL.getStatesQuery}`,
        {},
        {},
        successHandler,
        errorHandler
      );
    },
    handleStateSelected(stateid) {
      this.districtData = null;
      this.statedId = stateid;
      console.log(stateid);
      const successHandler = (response) => {
        if (response.status === 200) {
          this.districtData = response.data.results;
        }
      };

      const errorHandler = (response) => {
        this.showToast("Something went wrong internally!", "error", 10000);
      };

      this.requestGET(
        `${API_URL.getDistricst}?per_page=300&state=${stateid}`,
        {},
        {},
        successHandler,
        errorHandler
      );
    },
    interestAPIcall() {
      const successHandler = (response) => {
        if (response.status === 200) {
          console.log("interest", response.data);
          this.interests = response.data;
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };

      this.requestGET(
        `${API_URL.interests}`,
        {},
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        300000
      );
    },
    getBrands() {
      const successHandler = (response) => {
        if (response.status === 200) {
         // console.log("interest", response.data);
          this.brands = response.data;
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };

      this.requestGET(
        `${API_URL.brands}`,
        {},
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        300000
      );
    },
    getCrops() {
      const successHandler = (response) => {
        if (response.status === 200) {
         // console.log("interest", response.data);
          this.crops = response.data;
          const cropDataFormatted = [];
          response.data.map((item) => {
            const data = {
              crop_type: item.crop_type,
              crop_type_id: item.crop_type_id,
              isSelect: false,
              isAllSelect: false,
              crops: [],
            };
            cropDataFormatted.push(data);
          });
         // console.log("cropDataFormatted", cropDataFormatted);
          this.$store.dispatch(
            "crmFilters/setCropsFormatted",
            cropDataFormatted
          );
        }
      };

      const errorHandler = (error) => {
        this.showToast("Something went wrong internally!", "error", 10000);
        console.log(error);
      };

      this.requestGET(
        `${API_URL.crops}`,
        {},
        {},
        successHandler,
        errorHandler,
        process.env.VUE_APP_API_BASE_URL_DISCOVERY,
        300000
      );
    },
    //handle functions for filter data
    getSelectedBrand(data) {
      //console.log(data);
      //this.selectedBrand = data;
    },
    checkActionAndAct() {
      const locations_from_store =
        this.$store.getters["crmFilters/GET_STATES_DATA"];
      const intersets_from_store =
        this.$store.getters["crmFilters/GET_INTERESTS_DATA"];
      const other_intersets_from_store =
        this.$store.getters["crmFilters/GET_OTHER_INTERESTS_DATA"];
      const crops_from_store =
        this.$store.getters["crmFilters/GET_CROPS_FORMATTED_DATA"];
      const insurance_from_store =
        this.$store.getters["crmFilters/GET_INSURANCE_DATA"];
      const brands_from_store =
        this.$store.getters["crmFilters/GET_BRANDS_DATA"];
      const engagement_from_store = this.$store.getters["crmFilters/GET_ENGAGEMENT_DATA"];
      //  alert(JSON.stringify(engagement_from_store))
       const ownership_from_store =this.$store.getters["crmFilters/GET_FILTER_PAYLOAD"]
       // this.$store.getters["crmFilters/GET_OWNERSHIP_DATA"];
      // alert(JSON.stringify(ownership_from_store))
      const cropType = [];
      const cropsId = [];
      const risk_levels = [];
      if(engagement_from_store?.progression.click){
        if(engagement_from_store.progression.low){
          risk_levels.push('Low')
        }
        if(engagement_from_store.progression.med){
            risk_levels.push('Mid')
        }
        if(engagement_from_store.progression.high){
            risk_levels.push('High')
        }
      }
      crops_from_store.map((crop) => {
        if (crop.isAllSelect || crop.isSelect) {
          cropType.push(crop.crop_type_id);
        }

        if (crop.isSelect || crop.isAllSelect) {
          cropsId.push(...crop.crops);
        }
      });
      //const enagagement_data=engagement_from_store;

      const payload = {
        location: {
          state_id: locations_from_store,
          district_id: [],
        },
        interest: {
          other_interest: other_intersets_from_store,
          business_interest: intersets_from_store,
        },
        crops: {
          crop_type_id: cropType,
          crop_id: cropsId,
        },
        insurance: {
          crop_insurance:
            insurance_from_store && insurance_from_store?.crops == true
              ? "Yes"
              : insurance_from_store.crops == false
              ? "No"
              : null,
          tractor_insurance:
            insurance_from_store && insurance_from_store?.tractor == true
              ? "Yes"
              : insurance_from_store.tractor == false
              ? "No"
              : null,
          health_insurance:
            insurance_from_store && insurance_from_store?.health == true
              ? "Yes"
              : insurance_from_store.health == false
              ? "No"
              : null,
          other_insurance:
            insurance_from_store && insurance_from_store?.others == true
              ? "Yes"
              : insurance_from_store.others == false
              ? "No"
              : null,
        },
        engagement: {
          life_time_value: {
            min_value:engagement_from_store?.farmerLongTime.click? engagement_from_store.farmerLongTime.min:null,
            max_value: engagement_from_store?.farmerLongTime.click?engagement_from_store.farmerLongTime.max:null,
          },
          profile_completion: {
             min_value:engagement_from_store?.profileScore.click? engagement_from_store.profileScore.min:null,
            max_value: engagement_from_store?.profileScore.click?engagement_from_store.profileScore.max:null,
          },
          risk_level: risk_levels.length>0?risk_levels:[],
        },
        ownership: {
          land: {
            land_ownership: ownership_from_store?.ownership.land?.land_ownership==1?"Yes":ownership_from_store.ownership.land?.land_ownership=="No"?false:null,
            land_holding_size: ownership_from_store?.ownership.land.land_holding_size?ownership_from_store?.ownership.land.land_holding_size:[],
          },
          tractor: {
            tractor_ownership: ownership_from_store?.ownership.tractor?.tractor_ownership==1?"Yes":ownership_from_store.ownership.tractor?.tractor_ownership=="No"?false:null,
            tractor_brand: ownership_from_store?.ownership.tractor_brand?ownership_from_store?.ownership.tractor_brand:[],
          },
          cattle: {
            animal_ownership:  ownership_from_store.ownership.cattle?.animal_ownership==1?"Yes":ownership_from_store.ownership.cattle?.animal_ownership=="No"?false:null,
            animal_own_count: ownership_from_store.ownership.cattle.animal_own_count? ownership_from_store.ownership.cattle.animal_own_count:[],
            animal_interest: ownership_from_store.ownership.cattle.animal_interest?ownership_from_store.ownership.cattle.animal_interest:[],
          },
        },
        brands: brands_from_store?brands_from_store:[],
      };
      console.log("payload", payload);
      this.$store.dispatch("crmFilters/setFilterPayload", payload);
      this.$store.dispatch("crmFilters/setPage", 1);
      this.$store.dispatch("crmFilters/setFilterApplied", true);

      this.toggleDialog();
      this.getUserDetails();
      this.isfilterApplied();
    },
    //applyFilters() 
  },
};
</script>

<style lang="scss" scoped>
.custom-product-dialog.v-dialog {
  background-color: white;
}
.content-dialog {
  background-color: white;
  height: 600px;
}
.heading-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px 20px 0px 20px;
}
.filter-text {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  /* Greyscale/1 */
  color: #3a3f3a;
}
.publish {
  width: 160px;
}
.checkbox {
  transform: translateY(-10px);
}
@media all and (min-width: 1500px) {
  .custom-product-dialog.v-dialog {
    width: 50%;
  }
}
.heading {
  font-weight: 500;
  font-size: 20px;
  margin: 10px 0px 0px 28px;
}
.expand {
  //border-bottom: 1px solid #efefef;
  z-index: unset;
}
.noexpand {
  width: 80%;
  display: flex;
  justify-content: flex-end;

  border-bottom: 1px solid #efefef;
}
.expand .v-expansion-panels {
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style-type: none;
  padding: 0;
  width: 100%;
  position: inherit;
  margin-bottom: 5px;
}
.selected {
  background-color: #f3faf5;
  color: #189d3b;
  font-weight: 500;
  font-size: 16px;

  /* Add any other styles for selected engagement */
}
.selectionSection {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */
  padding-left: 24px;
  margin-bottom: 0px;
  /* Greyscale/Gray 3 */
  margin-top: 7px;
  color: #189d3b !important;
}
.selectionSection.selected-engagement {
  color: red;
}
</style>
